import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

/**
 * KarteX tasarım A paleti (2026-10-15). Birincil mor yalnız eylem ve etkin öğede; açık temada 600 (#5B3FE3),
 * koyu temada 400. Koyu yüzey lacivert (950 = #0B1020). Ray/lacivert marka tokenları (--kx-*) _kartex.scss'te.
 */
export const KARTEX_PRIMARY = {
    50: '#f1eeff',
    100: '#e4deff',
    200: '#cbbeff',
    300: '#b3a1ff',
    400: '#9b87ff',
    500: '#7a5ff0',
    600: '#5b3fe3',
    700: '#4a2fc7',
    800: '#3b25a0',
    900: '#2e1e7c',
    950: '#1c1250'
} as const;

/** Koyu tema yüzeyi: lacivert (Aura varsayılanı zinc yerine). */
export const KARTEX_NAVY = {
    0: '#ffffff',
    50: '#e7eaf3',
    100: '#c9cfe0',
    200: '#a3acc5',
    300: '#7c87a6',
    400: '#5a6585',
    500: '#414c6b',
    600: '#323c58',
    700: '#24304a',
    800: '#1a2440',
    900: '#121a2e',
    950: '#0b1020'
} as const;

/** Yapılandırıcının birincil renk adı; LayoutService varsayılanı. */
export const KARTEX_PRIMARY_NAME = 'kartex';

/** Birincil rengin anlamsal eşlemesi; hem preset hem yapılandırıcı (updatePreset) aynı nesneyi kullanır. */
export const KARTEX_PRIMARY_EXT = {
    semantic: {
        primary: KARTEX_PRIMARY,
        colorScheme: {
            light: {
                primary: {
                    color: '{primary.600}',
                    contrastColor: '#ffffff',
                    hoverColor: '{primary.700}',
                    activeColor: '{primary.800}'
                },
                highlight: {
                    background: '{primary.50}',
                    focusBackground: '{primary.100}',
                    color: '{primary.700}',
                    focusColor: '{primary.800}'
                }
            },
            dark: {
                primary: {
                    color: '{primary.400}',
                    contrastColor: '{surface.950}',
                    hoverColor: '{primary.300}',
                    activeColor: '{primary.200}'
                },
                highlight: {
                    background: 'color-mix(in srgb, {primary.400}, transparent 84%)',
                    focusBackground: 'color-mix(in srgb, {primary.400}, transparent 76%)',
                    color: 'rgba(255,255,255,.87)',
                    focusColor: 'rgba(255,255,255,.87)'
                }
            }
        }
    }
};

/** Panelin genel preset'i: Aura + KarteX birincil + lacivert koyu yüzey + 10px alan köşesi. */
export const KartexPreset = definePreset(Aura, {
    semantic: {
        ...KARTEX_PRIMARY_EXT.semantic,
        formField: { borderRadius: '10px' },
        colorScheme: {
            light: KARTEX_PRIMARY_EXT.semantic.colorScheme.light,
            dark: { ...KARTEX_PRIMARY_EXT.semantic.colorScheme.dark, surface: KARTEX_NAVY }
        }
    },
    components: {
        button: { root: { label: { fontWeight: '600' } } }
    }
});
